<template>
    <div class="container">
        <v-chart ref="barChart" :options="mergedConfig" :initOptions="initOptions" :autoresize="true"/>
    </div>
</template>

<script>
import { deepMerge } from '@jiaminghi/charts/lib/util/index'
import { deepClone } from '@jiaminghi/c-render/lib/plugin/util'
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/polar';
import 'echarts/lib/component/markPoint';
import 'echarts/lib/component/dataZoom';
import 'echarts/lib/component/title';
import 'echarts/lib/component/tooltip'
import 'zrender/lib/svg/svg'

export default {
  name: 'barChart',
  props: {
    config: {
      type: Object,
      default: () => ({})
    },
    data: {
        type: Array,
        default: () => []
    }
  },
  data () {
    return {
        initOptions: {renderer: 'svg'},
        option:{},
        defaultConfig: {
            title: {
                text: '周销售额趋势',
                show: false
            },
            grid: {
                top: this.fontSize(90),
                left: this.fontSize(50),
                right: this.fontSize(15),
                bottom: this.fontSize(45)
            },
            dataZoom: [
                {
                    type: 'inside',
                    show: false,
                    realtime: false,
                    startValue: 0,
                    endValue: 6,
                    handleSize: 5,
                }
            ],
            tooltip: {
                trigger: 'axis',
                // triggerOn: "mousemove",
                alwaysShowContent:true,
                axisPointer:{
                    type:'line',
                    lineStyle:{
                        color:'#EACD2C'
                    }
                },
                textStyle:{
                    fontSize: this.fontSize(18),
                    lineHeight: this.fontSize(25)
                },
                backgroundColor:"#000000",
                position: ['35%', '10%'],
                formatter: function (value){
                    let name = value[0].name
                    let result = name.replace("/","月")+"日" + " " + value[0].value
                return result
                }
            },
            xAxis:[ {
                type: "category",
                data: [],
                axisLabel: {
                    fontSize:  this.$isMobile()!="phone"? this.fontSize(10):this.chartFontSize-2,
                    color:'#FFFFFF',
                    rotate: this.fontSize(-30),
                    margin: this.fontSize(20),
                    showMaxLabel: true,
                    align: "center"
                },
                axisTick: {
                    show: false
                },
                axisLine: {
                    lineStyle: {
                        color: "rgba(41, 44, 56, 1)"
                    }
                },
                splitLine: {
                    show: true,
                    lineStyle: {
                        width: this.fontSize(1),
                        color: "#292C38"
                    }
                }
            }],
            yAxis: [{
                type: "value",
                minInterval: 1000,
                interval: 1000,
                axisLabel: {
                    fontSize: this.$isMobile()!="phone"? this.fontSize(10):this.chartFontSize-2,
                    color:'#FFFFFF'
                },
                axisLine: {
                    show: false
                },
                splitLine: {
                    show: true,
                    lineStyle: {
                        width: this.fontSize(1),
                        color: "#292C38"
                    }
                }
            }],
            series: [{
                    name:'',
                    data: [],
                    type: 'bar',
                    itemStyle:{
                        normal:{
                            barBorderRadius:[this.fontSize(30),this.fontSize(30),0,0],
                            color: function(params) {
                                var colorList = [{
                                    type: 'linear',
                                    x: 0,
                                    y: 0,
                                    x2: 0,
                                    y2: 1,
                                    colorStops: [{
                                                offset: 0, color: '#377DFF' // 0% 处的颜色
                                    },{
                                                offset: 1, color: 'rgba(55,125,255,0.12)' // 100% 处的颜色
                                        }],
                                    globalCoord: true // 缺省为 false
                                },{
                                    type: 'linear',
                                    x: 0,
                                    y: 0,
                                    x2: 0,
                                    y2: 1,
                                    colorStops: [{
                                                offset: 0, color: '#16CEB9' // 0% 处的颜色
                                    },{
                                                offset: 1, color: 'rgba(22,206,185,0.10)' // 100% 处的颜色
                                        }],
                                    globalCoord: true // 缺省为 false
                                },
                                {
                                    type: 'linear',
                                    x: 0,
                                    y: 0,
                                    x2: 0,
                                    y2: 1,
                                    colorStops: [{
                                                offset: 0, color: '#FF5988' // 0% 处的颜色
                                    },{
                                                offset: 1, color: 'rgba(255,89,136,0.09)' // 100% 处的颜色
                                        }],
                                    globalCoord: true // 缺省为 false
                                },{
                                    type: 'linear',
                                    x: 0,
                                    y: 0,
                                    x2: 0,
                                    y2: 1,
                                    colorStops: [{
                                                offset: 0, color: '#EACD2C' // 0% 处的颜色
                                    },{
                                                offset: 1, color: 'rgba(234,205,44,0.00)' // 100% 处的颜色
                                        }],
                                    globalCoord: true // 缺省为 false
                                }]
                                return colorList[0];

                            },
                            
                        }
                    },
                    barCategoryGap:'60%'
                }]
        },
        mergedConfig: null,
        timer:null,
        FLAG: 0,
        cursor: 0
    }
  },
  watch: {
    data() {
      const { calcData } = this
      calcData()
    }
  },
  methods: {

    fontSize(res){
        let clientWidth = window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth;
        if (!clientWidth) return;
        let fontSize = (clientWidth / 1920);
        return res*fontSize;
    },
    calcData() {
      const { mergeConfig } = this

      mergeConfig()

    },
    mergeConfig() {
        let { config, defaultConfig, data,$refs } = this
        let _this = this
        this.mergedConfig = deepMerge(
            deepClone(defaultConfig, true),
            config || {}
        )
        if(this.FLAG == 0){
            this.mergedConfig.xAxis[0].data=[]
            this.mergedConfig.series[0].data=[]
            data.forEach(function(item,index){
                if(index < _this.cursor+7){
                    _this.mergedConfig.xAxis[0].data.push(item.date)
                    _this.mergedConfig.series[0].data.push(item.count)
                }
            })
            this.cursor++
            $refs.barChart.dispatchAction({type: 'showTip',seriesIndex: 0,dataIndex: 3});
        }
        this.FLAG = 1
    },

  },
  mounted () {
    const { calcData,$refs,data } = this
    let _this = this
    calcData()
    this.timer = setInterval(()=>{
        _this.mergedConfig.xAxis[0].data=[]
        _this.mergedConfig.series[0].data=[]
        data.forEach(function(item,index){
            if(index>=_this.cursor && index < _this.cursor+7){
                _this.mergedConfig.xAxis[0].data.push(item.date)
                _this.mergedConfig.series[0].data.push(item.count)
            }
        })
        if(_this.cursor+7 > data.length){
            data.forEach(function(item,index){
                if(index< _this.cursor+7-data.length){
                    _this.mergedConfig.xAxis[0].data.push(item.date)
                    _this.mergedConfig.series[0].data.push(item.count)
                }
            })
        }
        if(_this.cursor< data.length){
            _this.cursor+=1
        }else{
            _this.cursor = 0
        }
        $refs.barChart.dispatchAction({type: 'showTip',seriesIndex: 0,dataIndex: 3});
    }, 1500);
  },
  beforeDestroy: function() {
            if (this.timer) {
                clearInterval(this.timer);
            }
  },
  components: {
      'v-chart': ECharts
  }
}
</script>
<style lang="scss" type="text/scss">

    .container{
        width: 100%;
        height: 100%;
        .echarts{
            width: 100%;
            height: 100%;
            .bar-poper{
                width: 64px;
                height: 42.2px;
                position: absolute;
                background-color: #000;
                border-width: 0px;
                border-color: #000;
                border-radius: 3px;
                font-size: 15px;
                color: #FFFFFF;
                text-align: left;
                &::after{
                    content:"";
                    display:block;
                    border-width: 10px 7px;
                    position:absolute; 
                    bottom:6px;
                    left:-7px;
                    border-style:dashed;
                    border-color: transparent #000 #000 transparent  ;
                    font-size:0;
                    transform:rotate(10deg);
                }
                .bar-value{
                    margin-left: 10px;
                    margin-top: 3px;
                }
            }
        }
    }

</style>